import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_REQUEST_MUTATION = graphql(/* GraphQL */ `
  mutation ContractDemandRequestUpdate($demandId: UUID!, $data: TsrctContractDemandRequestLineItemsInput!) {
    tesseract {
      contractDemand(id: $demandId) {
        contractDemandRequest {
          updateLineItems(data: $data) {
            id
            currency
            lineItems {
              id
              createdAt
              title
              description
              deliveryLocationId
              organizationId
              unitId
              quantity
              commodityGroupId
              commodityId
              baselinePricePerUnit
              baselinePricePerPriceUnit
              minimumOrderQuantity
              priceUnit
              qualifiedSuppliers
              totalValue
            }
          }
        }
      }
    }
  }
`);
